import React from "react"
import cx from "classnames"
import { useTranslation } from "react-i18next"
import getLocationHash from "@pag/utils/getLocationHash"

import ownTranslationsDe from "../../translations/no_translation_de.json"
import ownTranslationsEn from "../../translations/no_translation_en.json"

import "./i18nLabel.scss"

interface Ii18nLabel {
  text: string | TemplateStringsArray
  className?: string
  id?: string
  nonI18n?: boolean
  interpolationKeys?: any
}

const I18nLabel: React.FunctionComponent<Ii18nLabel> = (props) => {
  const { t, i18n } = useTranslation("center")

  const lng = localStorage.getItem("locale")
  const getLabel = () => {
    let text: string | TemplateStringsArray = ""
    //@ts-ignore
    if (lng === "de_DE" && ownTranslationsDe[props.text]) {
      // @ts-ignore
      text = ownTranslationsDe[props.text]
      // @ts-ignore
    } else if (ownTranslationsEn[props.text]) {
      // @ts-ignore
      text = ownTranslationsEn[props.text]
    } else {
      text = props.text
    }
    if (lng && lng !== i18n.language) i18n.changeLanguage(lng)
    return (
      <div id={props.id} className={cx("i18nLabel", props.className)}>
        <span className="label__span">{t(text, { ...props.interpolationKeys })}</span>
      </div>
    )
  }

  return getLabel()
}

export default I18nLabel
